import { getLorryDetailsByType } from "@vahak/core/dist/constants/lorryTypes";
import { cityStringIncludeParentheses } from "@vahak/core/dist/methods/cityStringIncludeParentheses";

export const VahakAppDownloadLink = "https://vahak.page.link/YyZk";

export async function getLoadShareText(data: any, isMobile: boolean, shortLink: string) {
    return `${data?.source_text || data?.source} to ${data?.destination_text || data?.destination} - ${
        data?.quantity
    } ${getLorryDetailsByType(data?.lorry_type_id || data?.lorry_id)?.unit} ${
        data?.lorry_type_text || data?.load_details?.lorry_type_text || data?.lorry_type
    } required. *Click the link to Book this load today: ${shortLink}*%0A%0ARegards,%0A${
        data.company?.name || data?.company_name || data.transporter_name
    }%0A${
        data.company?.service_type || data.company_service_type || ""
    }%0A%0AConnect %26 Deal with me regularly on Vahak: ${VahakAppDownloadLink}`;
}

export async function getLorryShareText(data: any, isMobile: boolean, shortLink: string) {
    return `${
        data?.lorry_detail?.type || data.lorry_type_text || `${data.capacity} ${data.capacity_unit} ${data.name}`
    } available in ${cityStringIncludeParentheses(
        data.current_city_name || data?.lorry_detail?.current_city || data.current_city
    )}. *Click the link to Book this lorry today: ${shortLink}*%0A%0ARegards,%0A${
        data.company_details?.name ||
        data.transporter_name ||
        data?.company_detail?.name ||
        data?.company_details?.company_name
    }%0A${
        data.company_details?.service_type || data?.company_detail?.service_type || data.company_service_type || ""
    }%0A%0AConnect %26 Deal with me regularly on Vahak: ${VahakAppDownloadLink}`;
}
